import { useState, useEffect, useCallback } from 'react'
import api from '../api/client'
import Modal from './Modal'

/**
 * Buscador del maestro de vendedores Presea (vendedores_presea).
 * Por default lista solo ACTIVOS; el toggle "incluir inactivos" trae todos.
 * Devuelve el código numérico que se manda a Presea como cliente.vendedor.
 */
export default function ModalListaVendedores({ onSelect, onClose }) {
  const [q, setQ] = useState('')
  const [vendedores, setVendedores] = useState([])
  const [loading, setLoading] = useState(false)
  const [incluirInactivos, setIncluirInactivos] = useState(false)

  const cargar = useCallback(async (busq, incluir) => {
    setLoading(true)
    try {
      const params = { limit: 100 }
      if (busq) params.q = busq
      if (incluir) params.incluir_inactivos = 1
      const { data } = await api.get('/vendedores', { params })
      setVendedores(Array.isArray(data) ? data : (data.data || []))
    } catch { setVendedores([]) } finally { setLoading(false) }
  }, [])

  useEffect(() => {
    const t = setTimeout(() => cargar(q, incluirInactivos), 200)
    return () => clearTimeout(t)
  }, [q, incluirInactivos, cargar])

  return (
    <Modal title="Seleccionar vendedor" onClose={onClose} maxWidth="540px">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <input
          autoFocus
          style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.875rem' }}
          placeholder="Buscar por nombre o código..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8125rem', color: '#475569' }}>
          <input type="checkbox" checked={incluirInactivos} onChange={(e) => setIncluirInactivos(e.target.checked)} />
          Incluir inactivos
        </label>
        <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{vendedores.length} vendedores</div>
        {/* Altura FIJA (no maxHeight): el modal no salta mientras se tipea —
            la lista scrollea adentro (regla Martin 14 ago). */}
        <div style={{ height: '380px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '6px' }}>
          {loading ? (
            <p style={{ padding: '1rem', color: '#94a3b8', textAlign: 'center' }}>Cargando...</p>
          ) : vendedores.length === 0 ? (
            <p style={{ padding: '1rem', color: '#94a3b8', textAlign: 'center' }}>Sin resultados.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: '#f8fafc' }}>
                  <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', fontWeight: '600', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Código</th>
                  <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', fontWeight: '600', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Nombre</th>
                  <th style={{ padding: '0.5rem 0.75rem', textAlign: 'right', fontWeight: '600', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>Suc.</th>
                </tr>
              </thead>
              <tbody>
                {vendedores.map(v => (
                  <tr
                    key={v.codigo}
                    onClick={() => { onSelect(v); onClose() }}
                    style={{ cursor: 'pointer', borderBottom: '1px solid #f1f5f9', opacity: v.inactivo ? 0.55 : 1 }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <td style={{ padding: '0.5rem 0.75rem', fontFamily: 'monospace', color: '#0f172a' }}>{v.codigo}</td>
                    <td style={{ padding: '0.5rem 0.75rem' }}>
                      {v.nombre}
                      {v.inactivo && <span style={{ marginLeft: '0.5rem', fontSize: '0.7rem', color: '#dc2626' }}>INACTIVO</span>}
                    </td>
                    <td style={{ padding: '0.5rem 0.75rem', textAlign: 'right', color: '#64748b' }}>{v.sucursal || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Modal>
  )
}
